import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
function ResponsiveReportContainer({
  children,
  isXYVisual = true,
  isMobile = false,
  'data-test-id': dataTestId
}) {
  if (!isXYVisual && !isMobile) {
    return /*#__PURE__*/_jsx(Flex, {
      "data-test-id": dataTestId,
      flexDirection: "column",
      flexGrow: 1,
      blockSize: "100%",
      overflow: "auto",
      "data-status-id": "report-status-loaded",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    blockSize: "100%",
    overflow: "auto",
    flexGrow: 1,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      blockSize: "100%",
      alignItems: "stretch",
      justifyContent: "center",
      position: "relative",
      children: children
    })
  });
}
export default ResponsiveReportContainer;